import { render, staticRenderFns } from "./SelfServiceListCustom.vue?vue&type=template&id=f60bea7c&"
import script from "./SelfServiceListCustom.vue?vue&type=script&lang=js&"
export * from "./SelfServiceListCustom.vue?vue&type=script&lang=js&"
import style0 from "./SelfServiceListCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports